import { render } from "./ScheduleSection.vue?vue&type=template&id=36940b65"
import script from "./ScheduleSection.vue?vue&type=script&lang=js"
export * from "./ScheduleSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__